import { Components } from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import { uberThemeDarkColors, uberThemeLightColors } from './uberThemeColors';

export const uberLightThemeComponents: Components = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        height: '100%',
        fontSize: '10px',
      },
      body: {
        height: '100%',
        margin: '0px auto',
      },
      a: {
        color: uberThemeLightColors.secondaryDarkColor,
        textDecoration: 'none',
        fontWeight: 400,
        fontSize: '1.6rem',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
      '#root': {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
      },
      'div,ul,tbody': {
        scrollbarWidth: 'thin',
        scrollbarColor: `#888888 #595959`,
        '&::-webkit-scrollbar': {
          width: 12,
          height: 6,
        },
        '&::-webkit-scrollbar-track': {
          background: uberThemeLightColors.primaryDarkColor,
        },
        '&::-webkit-scrollbar-thumb': {
          background: uberThemeLightColors.secondaryMainColor,
        },
      },
      '& .MuiCalendarPicker-root': {
        '& .MuiPickersDay-root': {
          fontSize: '1.6rem',
        },
        '& .MuiTypography-root': {
          fontSize: '1.6rem',
        },
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 0,
        fontSize: '1.6rem',
        fontWeight: 600,
        textTransform: 'none',
      },
      containedSecondary: {
        backgroundColor: uberThemeLightColors.secondaryDarkColor,
        '&:hover': {
          backgroundColor: uberThemeLightColors.secondaryMainColor,
        },
      },
      outlinedSecondary: {
        borderColor: uberThemeLightColors.secondaryDarkColor,
        color: uberThemeLightColors.secondaryDarkColor,
        '&:hover': {
          borderColor: uberThemeLightColors.secondaryMainColor,
          color: uberThemeLightColors.secondaryMainColor,
        },
      },
      outlinedPrimary: {
        borderColor: uberThemeLightColors.primaryContrastText,
        color: uberThemeLightColors.primaryContrastText,
        '&:hover': {
          borderColor: uberThemeLightColors.secondaryMainColor,
          color: uberThemeLightColors.secondaryMainColor,
        },
      },
      outlined: {
        borderWidth: 2,
        '&:hover': {
          borderWidth: 2,
        },
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        cursor: 'pointer',
        fontWeight: 400,
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: uberThemeLightColors.errorMainColor,
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        '& .MuiSvgIcon-root': {
          width: 20,
          height: 20,
        },
        '&:not(.Mui-checked)': {
          '& .MuiSvgIcon-root': {
            width: 20,
            height: 20,
          },
        },
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: `${uberThemeLightColors.secondaryDarkColor}!important`,
          color: uberThemeLightColors.secondaryContrastText,
        },
      },
      today: {
        backgroundColor: `${uberThemeLightColors.secondaryLightColor}!important`,
        color: uberThemeLightColors.primaryContrastText,
      },
    },
  },
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        backgroundColor: uberThemeLightColors.primaryMainColor,
      },
    },
  },
  MuiClockPicker: {
    styleOverrides: {
      root: {
        backgroundColor: uberThemeLightColors.primaryMainColor,
        '&>div:nth-of-type(2)>div': {
          '&>div:nth-of-type(2)': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(3)': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(4) span.Mui-selected': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
            color: uberThemeLightColors.secondaryContrastText,
          },
        },
        '&>div>div': {
          '&>div:nth-of-type(2)': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(3)': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(4) span.Mui-selected': {
            backgroundColor: uberThemeLightColors.secondaryDarkColor,
            color: uberThemeLightColors.secondaryContrastText,
          },
        },
      },
    },
  },
};

export const uberDarkThemeComponents: Components = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        height: '100%',
        fontSize: '10px',
      },
      body: {
        height: '100%',
        margin: '0px auto',
      },
      a: {
        color: uberThemeDarkColors.secondaryContrastText,
        textDecoration: 'none',
        fontWeight: 400,
        fontSize: '1.6rem',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
      '#root': {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
      },
      'div,ul,tbody': {
        scrollbarWidth: 'thin',
        scrollbarColor: `#888888 #595959`,
        '&::-webkit-scrollbar': {
          width: 12,
          height: 6,
        },
        '&::-webkit-scrollbar-track': {
          background: uberThemeDarkColors.primaryDarkColor,
        },
        '&::-webkit-scrollbar-thumb': {
          background: uberThemeDarkColors.secondaryMainColor,
        },
      },
      '& .MuiCalendarPicker-root': {
        '& .MuiPickersDay-root': {
          fontSize: '1.6rem',
        },
        '& .MuiTypography-root': {
          fontSize: '1.6rem',
        },
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 0,
        fontSize: '1.6rem',
        fontWeight: 600,
        textTransform: 'none',
      },
      outlinedPrimary: {
        fontWeight: 400,
        color: uberThemeDarkColors.primaryContrastText,
        borderColor: uberThemeDarkColors.primaryContrastText,
        transition: '0.2s',
        '&:hover': {
          opacity: 0.8,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          borderColor: uberThemeDarkColors.primaryContrastText,
        },
      },
      outlinedSecondary: {
        borderColor: uberThemeDarkColors.secondaryMainColor,
        color: uberThemeDarkColors.secondaryContrastText,
        '&:hover': {
          borderColor: uberThemeDarkColors.secondaryDarkColor,
        },
      },
      outlined: {
        borderWidth: 2,
        '&:hover': {
          borderWidth: 2,
        },
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        cursor: 'pointer',
        fontWeight: 400,
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: uberThemeDarkColors.errorMainColor,
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        '& .MuiSvgIcon-root': {
          width: 20,
          height: 20,
        },
        '&:not(.Mui-checked)': {
          '& .MuiSvgIcon-root': {
            width: 20,
            height: 20,
          },
        },
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        backgroundColor: uberThemeDarkColors.primaryDarkColor,
        '&.Mui-selected': {
          backgroundColor: `${uberThemeDarkColors.secondaryDarkColor}!important`,
          color: uberThemeDarkColors.secondaryContrastText,
        },
      },
      today: {
        backgroundColor: `${uberThemeDarkColors.secondaryMainColor}!important`,
        color: uberThemeDarkColors.primaryContrastText,
      },
    },
  },
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        backgroundColor: uberThemeDarkColors.primaryMainColor,
      },
    },
  },
  MuiClockPicker: {
    styleOverrides: {
      root: {
        backgroundColor: uberThemeDarkColors.primaryMainColor,
        '&>div:nth-of-type(2)>div': {
          '&>div:nth-of-type(2)': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(3)': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(4) span.Mui-selected': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
            color: uberThemeDarkColors.secondaryContrastText,
          },
        },
        '&>div>div': {
          '&>div:nth-of-type(2)': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(3)': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
          },
          '&>div:nth-of-type(4) span.Mui-selected': {
            backgroundColor: uberThemeDarkColors.secondaryDarkColor,
            color: uberThemeDarkColors.secondaryContrastText,
          },
        },
      },
    },
  },
};
